<template>
  <div class="aspect-agreement-container">
    <div class="aspect-header">
      <RenderVHtml
        class="aspect-text-content"
        :content="aspect.text"
      ></RenderVHtml>
      <div class="aspect-actions" v-if="allows_crud">
        <ButtonSmall
          :tooltip_text="$t('toolbar.acts.addAgreement')"
          :text_button="``"
          :click_button="
            () => $bvModal.show(`modal-agreement-${act_id}-${aspect_id}`)
          "
          :icon="'plus'"
          :variant="'none'"
          :custom_class="``"
        >
        </ButtonSmall>
      </div>
    </div>

    <div class="agreements-wrapper">
      <template v-for="agreement in agreements">
        <div class="agreement-card" :key="agreement.id">
          <div
            :class="
              allows_crud
                ? 'agreement-content-with-actions'
                : 'agreement-content'
            "
          >
            <div class="agreement-row">
              <div class="agreement-field-label text-left">
                {{ $t("toolbar.acts.complianceDate") }}
              </div>
              <div class="agreement-field-value">
                {{ agreement.compliance_date }}
              </div>
              <div class="agreement-field-label">
                {{ $t("toolbar.acts.agreement") }}
              </div>
              <div class="agreement-field-value agreement-text">
                {{ agreement.agreement }}
              </div>
            </div>
            <div class="agreement-row">
              <div class="agreement-field-label">
                {{ $t("toolbar.acts.compliance") }}
              </div>
              <div class="agreement-field-value">
                <template v-if="allows_crud">
                  <b-form-select
                    v-model="agreement.is_fulfilled"
                    :options="FulfillTypes"
                    @change="patchAgreement(agreement)"
                    value-field="id"
                    text-field="value"
                  ></b-form-select>
                </template>
                <template v-else>
                  {{ fulfillment(agreement) }}
                </template>
              </div>
              <div class="agreement-field-label">
                {{ $t("toolbar.acts.responsibles") }}
              </div>
              <div class="agreement-field-value agreement-text">
                {{ agreement.responsibles }}
              </div>
            </div>
            <div class="agreement-row">
              <div class="agreement-field-label observations-label">
                {{ $t("toolbar.acts.observations") }}
              </div>
              <div class="agreement-field-value observations-value">
                {{ agreement.observations }}
              </div>
            </div>
          </div>
          <div v-if="allows_crud" class="agreement-actions">
            <ButtonSmall
              :tooltip_text="$t('toolbar.acts.editAgreement')"
              :text_button="``"
              :click_button="() => launchUpdateModal(agreement)"
              :icon="'square'"
              :variant="'none'"
              :custom_class="`ml-1 mb-1`"
            >
            </ButtonSmall>
            <ButtonSmall
              :tooltip_text="$t('toolbar.acts.deleteAgreement')"
              :text_button="``"
              :click_button="() => launchDelete(agreement)"
              :icon="'trash'"
              :variant="'none'"
              :custom_class="`ml-1 mb-1`"
            >
            </ButtonSmall>
          </div>
        </div>
      </template>
    </div>
    <!-- Modals -->
    <b-modal
      :id="`modal-agreement-${act_id}-${aspect_id}`"
      :title="
        selected_agreement
          ? $t('toolbar.acts.editAgreement')
          : $t('toolbar.acts.createAgreement')
      "
      hide-footer
      @hide="hideModal"
      size="lg"
    >
      <AspectAgreementForm
        :Agreement="selected_agreement"
        :act_id="act_id"
        :aspect_id="aspect_id"
        :Aspects="Aspects"
        :FulfillTypes="FulfillTypes"
        :allows_crud="true"
        @created="slotCreateAgreement"
        @updated="slotUpdateAgreement"
      ></AspectAgreementForm>
    </b-modal>
  </div>
</template>

<script>
import { toast } from "@/utils/utils";

export default {
  name: "AspectAgreement",
  components: {
    AspectAgreementForm: () => import("./AspectAgreementForm"),
    ButtonSmall: () =>
      import("@/components/reusable/Buttons/Small/ButtonSmall"),
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
  },
  props: {
    Act: {
      type: Object,
      required: true,
    },
    act_id: {
      type: Number,
      required: true,
    },
    aspect_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      default: false,
    },
    Aspects: {
      type: Array,
      required: true,
    },
    FulfillTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      agreements: [],
      selected_agreement: null,
    };
  },
  computed: {
    aspect() {
      return this.Aspects.find((x) => x.id == this.aspect_id);
    },
  },
  methods: {
    fulfillment(agreement) {
      if (!agreement.is_fulfilled) return "";
      const type = this.FulfillTypes.find(
        (x) => x.id == agreement.is_fulfilled
      );
      return type.value;
    },
    fetchAgreements() {
      this.$restful
        .GetAll(`/cideu/agreement/?aspect=${this.aspect_id}`)
        .then((response) => {
          this.agreements = response;
        });
    },
    hideModal() {
      this.selected_agreement = null;
    },
    deleteAgreement(agreement) {
      this.$restful.Delete(`/cideu/agreement/${agreement.id}/`).then(() => {
        const index_aspect = this.Act.agreements.findIndex(
          (x) => x == agreement.id
        );
        if (index_aspect != -1) {
          this.Act.agreements.splice(index_aspect, 1);
        }
        const index_agreements = this.Act.agreements_fullfiled.findIndex(
          (x) => x == agreement.id
        );
        if (index_agreements != -1) {
          this.Act.agreements_fullfiled.splice(index_agreements, 1);
        }
        const index = this.agreements.findIndex((x) => x.id == agreement.id);
        if (index != -1) {
          this.agreements.splice(index, 1);
        }
        toast(this.$t("toolbar.acts.agreementDeleted"));
      });
    },
    slotCreateAgreement(agreement) {
      this.Act.agreements.push(agreement.id);
      this.agreements.push(agreement);
      this.$bvModal.hide(`modal-agreement-${this.act_id}-${this.aspect_id}`);
    },
    patchAgreement(agreement) {
      this.$restful
        .Patch(`/cideu/agreement/${agreement.id}/`, {
          is_fulfilled: agreement.is_fulfilled,
        })
        .then((response) => {
          this.slotUpdateAgreement(response);
          toast(this.$t("toolbar.acts.agreementUpdated"));
        });
    },
    slotUpdateAgreement(agreement) {
      this.$bvModal.hide(`modal-agreement-${this.act_id}-${this.aspect_id}`);
      if (this.Act.agreements_fullfiled.includes(agreement.id)) {
        if (agreement.is_fulfilled != 1) {
          const index = this.Act.agreements_fullfiled.findIndex(
            (x) => x == agreement.id
          );
          if (index != -1) this.Act.agreements_fullfiled.splice(index, 1);
        }
      } else {
        if (agreement.is_fulfilled == 1) {
          this.Act.agreements_fullfiled.push(agreement.id);
        }
      }
      const index = this.agreements.findIndex((x) => x.id == agreement.id);
      if (index != -1) {
        this.agreements.splice(index, 1, agreement);
      } else {
        this.agreements.push(agreement);
      }
    },
    launchUpdateModal(agreement) {
      this.selected_agreement = agreement;
      this.$bvModal.show(`modal-agreement-${this.act_id}-${this.aspect_id}`);
    },
    launchDelete(agreement) {
      this.$swal({
        title: this.$t("toolbar.acts.deleteAgreementConfirmation"),
        text: this.$t("reusable.common.deleteConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.deleteAgreement(agreement);
        }
      });
    },
  },
  created() {
    this.fetchAgreements();
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
.aspect-agreement-container {
  margin-bottom: var(--kl-space-4);
}

.aspect-header {
  display: flex;
  align-items: flex-start;
  background: var(--kl-surface-muted);
  padding: var(--kl-space-4);
  border: 1px solid var(--kl-table-border);
}

.aspect-text-content {
  flex: 1;
  text-align: justify;
  line-height: var(--kl-lh-base);
  color: var(--kl-text-body);
}

.aspect-actions {
  margin-left: var(--kl-space-4);
}

.agreements-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--kl-space-4);
}

.agreement-card {
  display: flex;
  border: 1px solid var(--kl-table-border);
  background: var(--kl-surface);
  overflow: hidden;
  page-break-inside: avoid;
}

.agreement-content,
.agreement-content-with-actions {
  flex: 1;
  display: grid;
  grid-template-columns: 200px 1fr 200px 2fr;
  grid-template-rows: auto auto auto;
}

.agreement-content-with-actions {
  width: calc(100% - 60px);
}

.agreement-row {
  display: contents;
}

.agreement-field-label {
  background: var(--kl-table-header-bg);
  color: var(--kl-table-header-text);
  padding: var(--kl-space-3) var(--kl-space-4);
  font-weight: var(--kl-fw-semibold);
  display: flex;
  align-items: center;
  border-bottom: 1px solid var(--kl-table-border);
}

.agreement-field-value {
  background: var(--kl-surface);
  padding: var(--kl-space-3) var(--kl-space-4);
  display: flex;
  align-items: center;
  color: var(--kl-table-text);
  border-bottom: 1px solid var(--kl-table-border);
  border-left: 1px solid var(--kl-table-border);
}

/* Última fila sin borde inferior */
.agreement-row:last-child .agreement-field-label,
.agreement-row:last-child .agreement-field-value {
  border-bottom: none;
}

/* Observaciones ocupa todo el ancho */
.observations-label {
  grid-column: 1;
}

.observations-value {
  grid-column: 2 / -1;
  text-align: justify;
}

.agreement-text {
  text-align: justify;
  width: 100%;
}

.agreement-actions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: var(--kl-space-2);
  background: var(--kl-surface-muted);
  border-left: 2px solid var(--kl-table-border);
  min-width: 60px;
}

/* Responsive */
@media (max-width: 1024px) {
  .agreement-content,
  .agreement-content-with-actions {
    grid-template-columns: 180px 1fr 180px 1.5fr;
  }
}

@media (max-width: 768px) {
  .agreement-card {
    flex-direction: column;
  }

  .agreement-content,
  .agreement-content-with-actions {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .agreement-row {
    display: flex;
    border-bottom: 1px solid var(--kl-table-border);
  }

  .agreement-row:last-child {
    border-bottom: none;
  }

  .agreement-field-label {
    min-width: 120px;
    border-bottom: none;
  }

  .agreement-field-value {
    flex: 1;
    border-right: none;
    border-bottom: none;
  }

  .observations-label {
    grid-column: auto;
  }

  .observations-value {
    grid-column: auto;
  }

  .agreement-actions {
    flex-direction: row;
    border-left: none;
    border-top: 2px solid var(--kl-table-border);
    min-width: auto;
  }
}

/* Print styles */
@media print {
  .agreement-card {
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .agreement-content,
  .agreement-content-with-actions {
    display: grid !important;
    grid-template-columns: 200px 1fr 200px 2fr !important;
    grid-template-rows: auto auto auto;
    width: 100% !important;
  }

  .agreement-row {
    display: contents !important;
  }

  .agreement-field-label {
    background: var(--kl-table-header-bg) !important;
    color: var(--kl-table-header-text) !important;
    padding: var(--kl-space-3) var(--kl-space-4) !important;
    font-weight: var(--kl-fw-semibold) !important;
    display: flex !important;
    align-items: center !important;
    border-bottom: 1px solid var(--kl-table-border) !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .agreement-field-value {
    background: var(--kl-surface) !important;
    padding: var(--kl-space-3) var(--kl-space-4) !important;
    display: flex !important;
    align-items: center !important;
    color: var(--kl-table-text) !important;
    border-bottom: 1px solid var(--kl-table-border) !important;
    border-left: 1px solid var(--kl-table-border) !important;
  }

  .observations-label {
    grid-column: 1 !important;
  }

  .observations-value {
    grid-column: 2 / -1 !important;
    text-align: justify !important;
  }

  .agreement-actions {
    display: none !important;
  }

  .aspect-actions {
    display: none !important;
  }
}
</style>